import StepBucket from 'pattern/StepBucket.js';
import {findStep} from './utils.js';

export const roll = (group, stepBuckets) => {
    let steps = [...group.steps];

    for (let step of steps.slice(0, steps.length - 1)) {
        let {stepNumber} = findStep(stepBuckets, step);
        let stepBucket = stepBuckets[stepNumber];

        for (let i=stepNumber + 2; i < stepBuckets.length; i+=2) {
            let _stepBucket = stepBuckets[i];
            if (_stepBucket.anyOn()) {
                // there is an on step here so break b/c we don't
                // need to do anything
                break;
            }
            // there is no on-step here so place the original stepbucket here
            stepBuckets[i] = stepBucket;
        }
    }
    return stepBuckets;
};
